import { BaseModel } from "../BaseModel";

export enum LutQueueStepId
{
    Queued = 1000,
    Parsing = 1001,
    GisQuery = 1002,
    Validation = 1003,
    CloudEngine = 1004,
    DuplicateCheck = 1005,
    Done = 1006,
    BmpGeneration = 1007,
    Finalizing = 1009,
    UserDuplicateInteraction = 1010
}

export default class LutQueueStep extends BaseModel {
    id: LutQueueStepId;
    internalName: string;
    displayName: string;
    displayWeight: number;
    active: number;
    editor: string | null;
    created: Date | string | null;
    updated: Date | string | null;

    constructor() {
        super("LutQueueStep", "local")
    }
}